import _classCallCheck from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * An {@link Emitter} implementation.
 * @internal
 */
export var EmitterImpl = /*#__PURE__*/function () {
  function EmitterImpl() {
    _classCallCheck(this, EmitterImpl);
    this.listeners = new Array();
  }
  /**
   * Sets up a function that will be called whenever the target changes.
   * @param listener - Callback function.
   * @param options - An options object that specifies characteristics about the listener.
   *                  If once true, indicates that the listener should be invoked at most once after being added.
   *                  If once true, the listener would be automatically removed when invoked.
   */
  _createClass(EmitterImpl, [{
    key: "addListener",
    value: function addListener(listener, options) {
      var _this = this;
      var onceWrapper = function onceWrapper(data) {
        _this.removeListener(onceWrapper);
        listener(data);
      };
      (options === null || options === void 0 ? void 0 : options.once) === true ? this.listeners.push(onceWrapper) : this.listeners.push(listener);
    }
    /**
     * Emit change.
     * @param data - Data to emit.
     */
  }, {
    key: "emit",
    value: function emit(data) {
      this.listeners.slice().forEach(function (listener) {
        return listener(data);
      });
    }
    /**
     * Removes all listeners previously registered with addListener.
     */
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners() {
      this.listeners = [];
    }
    /**
     * Removes a listener previously registered with addListener.
     * @param listener - Callback function.
     */
  }, {
    key: "removeListener",
    value: function removeListener(listener) {
      this.listeners = this.listeners.filter(function (l) {
        return l !== listener;
      });
    }
    /**
     * Registers a listener.
     * @param listener - Callback function.
     * @deprecated Use addListener.
     */
  }, {
    key: "on",
    value: function on(listener) {
      return this.addListener(listener);
    }
    /**
     * Unregisters a listener.
     * @param listener - Callback function.
     * @deprecated Use removeListener.
     */
  }, {
    key: "off",
    value: function off(listener) {
      return this.removeListener(listener);
    }
    /**
     * Registers a listener then unregisters the listener after one event emission.
     * @param listener - Callback function.
     * @deprecated Use addListener.
     */
  }, {
    key: "once",
    value: function once(listener) {
      return this.addListener(listener, {
        once: true
      });
    }
  }]);
  return EmitterImpl;
}();